
import { z } from "zod";

export const clienteFormSchema = z.object({
  geradorId: z.string().min(1, "Selecione um gerador"),
  nome: z.string().min(3, "Nome deve ter no mínimo 3 caracteres"),
  documento: z.string().min(11, "CPF/CNPJ inválido"),
  cep: z.string().min(8, "CEP inválido"),
  logradouro: z.string().min(1, "Logradouro é obrigatório"),
  bairro: z.string().min(1, "Bairro é obrigatório"),
  cidade: z.string().min(1, "Cidade é obrigatória"),
  estado: z.string().length(2, "Estado deve ter 2 caracteres"),
  concessionaria: z.string().min(1, "Selecione uma concessionária"),
  numeroCliente: z.string().min(1, "Número do cliente é obrigatório"),
  numeroInstalacao: z.string().min(1, "Número da instalação é obrigatório"),
  gastoEnergia: z.number().positive("Gasto deve ser maior que zero"),
  tarifaEnergia: z.number().positive("Tarifa deve ser maior que zero")
});

export type ClienteFormValues = z.infer<typeof clienteFormSchema>;

export const tarifaEditSchema = z.object({
  tarifaEnergia: z.number().positive("Tarifa deve ser maior que zero")
});

export type TarifaEditValues = z.infer<typeof tarifaEditSchema>;
